import { twMerge } from 'tailwind-merge';

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  formSelectSize?: 'sm' | 'lg';
}

function FormSelect({ formSelectSize, className, ...props }: FormSelectProps) {
  return (
    <select
      {...props}
      className={twMerge([
        'disabled:bg-slate-100 disabled:cursor-not-allowed disabled:dark:bg-darkmode-700/50',
        'bg-[length:20px_auto] bg-chevron-black transition duration-200 ease-in-out w-full text-sm border-slate-300/60 shadow-sm rounded-md py-2 px-3 pr-8 focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40 dark:!bg-darkmode-700 dark:focus:ring-slate-700 dark:focus:ring-opacity-50 dark:bg-chevron-white',
        formSelectSize === 'sm' && 'text-xs py-1.5 pl-2 pr-8',
        formSelectSize === 'lg' && 'text-lg py-1.5 pl-4 pr-8',
        className,
      ])}
    >
      {props.children}
    </select>
  );
}

export default FormSelect;
